
import {ensureSlug} from "../../utils/validation/ensureSlug";
import {queryGqlApi} from "../../graphql/queryGqlApi";
import {updateClient} from "../../graphql/mutations";
import { CrudServices } from "../../platform/services/types/ServiceDependencies";
import { UserSessionState } from "../../stores/UserSessionState";
import { RootStoreModel } from "../../stores/RootStore";

export interface CompanyUpdateObject {
    name?: string;
    slug?: string;
    inviteLink?: string;
    userRole?: string;
    defaultWorkspaces?: string;
}

export const updateCompany = async (
    services: CrudServices,
    userState: UserSessionState,
    rootStore: RootStoreModel,
    updatedAttributes: CompanyUpdateObject
) => {
    const updatedClient = await queryGqlApi(
        updateClient,
        {
            input: {
                id: userState.tenantId,
                version: userState.dsManager!.clientAR!.row!.version,
                ...updatedAttributes,
            }
        },
        services.dataClientService,
        services.authService,
        'pgServer'
    );

    rootStore.setClient(updatedClient);
    return updatedClient;
}

export const updateCompanyNameAndSlug = async (
    services: CrudServices,
    userState: UserSessionState,
    rootStore: RootStoreModel,
    newName: string
) => {
    const slug = await ensureSlug(newName);
    return await updateCompany(services, userState, rootStore, {
        name: newName,
        slug: slug,
    });
}
